import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { TLevel } from '@smartico/public-api/dist/WSAPI/WSAPITypes'
import { Smartico } from '../../core/Smartico'

interface LevelsState {
    levels: TLevel[] | null
    error: string | null
}

const initialState: LevelsState = {
    levels: null,
    error: null,
}

export const fetchLevels = createAsyncThunk('levels/fetchLevels', async (_, { rejectWithValue }) => {
    try {
        const smarticoApi = await Smartico.apiReady
        const response = await smarticoApi.getLevels()
        return response.sort((a, b) => a.required_points - b.required_points)
    } catch (error) {
        return rejectWithValue('Failed to fetch levels')
    }
})

const levelsSlice = createSlice({
    name: 'levels',
    initialState,
    reducers: {
        setLevels(state, action: PayloadAction<TLevel[]>) {
            state.levels = action.payload
        },
        updateLevels(state, action: PayloadAction<TLevel[]>) {
            state.levels = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLevels.pending, (state) => {
                state.levels = null
                state.error = null
            })
            .addCase(fetchLevels.fulfilled, (state, action) => {
                state.levels = action.payload
                state.error = null
            })
            .addCase(fetchLevels.rejected, (state, action) => {
                state.levels = null
                state.error = action.payload as string
            })
    },
})

export const { setLevels, updateLevels } = levelsSlice.actions

export default levelsSlice.reducer